import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { AuftragExportTemplate, SelectAuftragstypComponent } from './select-auftragstyp/select-auftragstyp.component';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { BatchAuftragDetailEntryMeta } from '../../../../core/batch-auftrag-api';
import { CapAlertService } from '../../../../core/extension/exceptions/cap-alert.service';
import { CapiWizardComponent } from '../../shared/capi-wizard/capi-wizard.component';
import { ContentHeaderComponent } from '../../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../../shared/components/title/title.component';
import { CdkStep, CdkStepLabel } from '@angular/cdk/stepper';
import { SelectAuftragsbestandComponent } from './select-auftragsbestand/select-auftragsbestand.component';
import { SelectAuftragsexportkriterienComponent } from './select-auftragsexportkriterien/select-auftragsexportkriterien.component';
import { SelectAuftragsoptionenComponent } from './select-auftragsoptionen/select-auftragsoptionen.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-auftrag-new',
  templateUrl: './auftrag-new.component.html',
  styleUrls: ['./auftrag-new.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    CapiWizardComponent,
    CdkStep,
    CdkStepLabel,
    SelectAuftragstypComponent,
    SelectAuftragsbestandComponent,
    SelectAuftragsexportkriterienComponent,
    SelectAuftragsoptionenComponent,
    TranslatePipe
  ]
})
export class AuftragNewComponent implements OnInit, AfterViewInit {
  currentTemplateSelected: AuftragExportTemplate;

  @ViewChild(CapiWizardComponent, { static: false })
  public wizard: CapiWizardComponent;

  @Input()
  readonly: boolean;

  private _auftrag: BatchAuftragDetailEntryMeta;

  get auftrag(): BatchAuftragDetailEntryMeta {
    return this._auftrag;
  }

  @Input()
  set auftrag(value: BatchAuftragDetailEntryMeta) {
    this._auftrag = value;
    if (this.readonly) {
      this.currentTemplateSelected = new AuftragExportTemplate(this._auftrag.templateDetailEntry);
    }
  }

  constructor(
    private cd: ChangeDetectorRef,
    private capAlertService: CapAlertService
  ) {
    keysToTranslate<string>([
      'datenexport.stapelverarbeitungsauftragErstellen',
      'datenexport.auswahlAuftragstyp',
      'datenexport.auswahlAuftragstyp_readonly',
      'datenexport.auswahlBetroffenerDatenbestand',
      'datenexport.auswahlBetroffenerDatenbestand_readonly',
      'datenexport.auswahlErgebnisoptionen',
      'datenexport.auswahlErgebnisoptionen_readonly',
      'datenexport.auswahlAuftragsoptionen',
      'datenexport.auswahlAuftragsoptionen_readonly'
    ]);
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.cd.detectChanges();
  }

  popAllAlerts() {
    this.capAlertService.dismissAll();
  }

  hasErgebnisoptionenStep(): boolean {
    return (
      !this.currentTemplateSelected ||
      this.currentTemplateSelected.model.exportKriterien.mExportEigentum.access !== 'DEACTIVATED' ||
      this.currentTemplateSelected.model.exportKriterien.mExportGrundstueckbeschreibung.access !== 'DEACTIVATED' ||
      this.currentTemplateSelected.model.exportKriterien.mExportStammperson.access !== 'DEACTIVATED'
    );
  }
}
